module.exports = __webpack_public_path__ + "static/media/41.3210b199.jpg";